import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="max-w-3xl mx-auto px-4 md:px-6 pt-6 pb-6 md:pt-14 md:pb-16 text-center" data-id="element-139">
      <FadeIn data-id="element-140">
        <h1 className="text-3xl md:text-6xl font-extrabold text-brown-900 tracking-tight mb-1 md:mb-2 leading-tight" data-id="element-141">
          How to Legally Lower Your Medical Bills
        </h1>
        <p className="max-w-lg mx-auto text-base md:text-xl text-brown-600 font-medium mt-1 mb-3" data-id="element-142">
          Without Fighting, Arguing, or Hiring an Advocate
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-143">
        <p className="max-w-xl mx-auto mb-2 md:mb-3 text-sm md:text-lg text-brown-800 leading-relaxed font-medium" data-id="element-144">
          Before you pay that bill, make sure it's right.
        </p>
        <p className="max-w-xl mx-auto mb-2 md:mb-2 text-sm md:text-lg text-brown-800 leading-relaxed" data-id="element-145">
          Many medical charges can be questioned and reduced, even after
          insurance processes them. Most families overpay simply because they
          don't know they can.
        </p>
        <p className="max-w-xl mx-auto mb-2 md:mb-3 text-sm md:text-lg text-brown-800 leading-relaxed font-medium" data-id="element-146">
          <span className="italic" data-id="element-147">Stop Overpaying Medical Bills</span> is a
          step-by-step digital blueprint that shows you exactly how to:
        </p>
        <ul className="max-w-md mx-auto mb-2 md:mb-3 text-left space-y-1" data-id="element-148">
          <li className="flex items-start gap-2 text-sm md:text-lg text-brown-800 leading-snug" data-id="element-149">
            <span className="text-terracotta-500 font-bold mt-0.5" data-id="element-150">✓</span>
            <span data-id="element-151">Review charges the right way</span>
          </li>
          <li className="flex items-start gap-2 text-sm md:text-lg text-brown-800 leading-snug" data-id="element-152">
            <span className="text-terracotta-500 font-bold mt-0.5" data-id="element-153">✓</span>
            <span data-id="element-154">Request proper itemization</span>
          </li>
          <li className="flex items-start gap-2 text-sm md:text-lg text-brown-800 leading-snug" data-id="element-155">
            <span className="text-terracotta-500 font-bold mt-0.5" data-id="element-156">✓</span>
            <span data-id="element-157">Use word-for-word scripts to ask for reductions</span>
          </li>
          <li className="flex items-start gap-2 text-sm md:text-lg text-brown-800 leading-snug" data-id="element-158">
            <span className="text-terracotta-500 font-bold mt-0.5" data-id="element-159">✓</span>
            <span data-id="element-160">Protect your savings before sending another dollar</span>
          </li>
        </ul>
        <p className="mx-auto mb-3 md:mb-4 text-sm md:text-lg text-terracotta-600 leading-none font-semibold whitespace-nowrap" data-id="element-161">
          You don't need to argue. You need a structure.
        </p>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-162">
        <div className="relative mx-auto max-w-[220px] md:max-w-sm shadow-2xl rounded-lg overflow-hidden mb-4 md:mb-5" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/oAmUMx8hxSmZppAwH3vM1B/Image_for_mockup_Original.png" alt="Stop Overpaying Medical Bills Ebook Cover" className="w-full h-auto" width={384} height={497} fetchPriority="high" decoding="async" data-id="element-164" />
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-165">
        <button onClick={() => {
        const el = document.getElementById('final-cta');
        if (el) el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }} className="inline-flex items-center justify-center px-7 py-4 md:px-8 md:py-5 text-base md:text-xl font-bold text-white bg-terracotta-500 rounded-full shadow-lg hover:bg-terracotta-600 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 group" data-id="element-166">
          Protect My Savings Now
          <ArrowRight className="ml-2 w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-167" />
        </button>
      </FadeIn>
    </section>;
}